import { Badge, Divider, Text } from "theme-ui";
import { TabelHeadingTxt } from "../../Text/TabelCommonTxt";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { ColumnDef } from "@tanstack/react-table";
import queryString from "query-string";
import DataTable from "../../Tabels/Tabel";
import { getAllBadges, getGamificationCriteria, getGamificationCriteriaUser } from "../../../store/actions/Rating.Action";
import moment from "moment";
import { getApiEndPoint } from "../../../utils/GenerateQueryString";

const BadgeHistory: React.FC = () => {
    const dispatch = useDispatch();
    const { gamificationCriteria, loader, earnedBadges, allBadges } = useSelector((state: any) => state.rating);
    const { paginations } = useSelector((state: any) => state.pagination);
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams({
        currentPage: "1",
        limit: "15",
    });
    const [refresh, setRefresh] = useState<boolean>(true);
    const limit = parseInt(searchParams.get('limit') || "15");
    const currentPage = parseInt(searchParams.get('currentPage') || "1");

    useEffect(() => {
        let apiEndPoint = getApiEndPoint({ limit, currentPage }, location.search, columns?.map((val: any) => ({ accessorKey: val.accessorKey, filterType: val.filterType })) || [], location?.pathname)
        dispatch(getGamificationCriteriaUser(apiEndPoint))
        setRefresh(false);
    }, [refresh, location?.search, limit, currentPage])
    useEffect(() => {
        dispatch(getGamificationCriteria())
        dispatch(getAllBadges())
    }, [])

    const transformedData = useMemo(() => {
        return earnedBadges?.data?.flatMap((badge: any) =>
            badge?.badgeHistory
                .filter((history: any) => history?.badgeId !== null)
                .map((history: any) => ({
                    id: history?._id,
                    CriteriaName: badge?.badgeCriteria?.name || "-",
                    color: badge?.badgeCriteria?.color,
                    icon: history?.badgeId?.icon,
                    badgeName: history?.badgeId?.name || "-",
                    achievedAt: history?.achievedAt ? moment(history.achievedAt.split('T')[0]).format("MMM DD, YYYY") : "-",
                }))
        ) || [];
    }, [earnedBadges?.data]);
    const columns = useMemo<ColumnDef<any>[]>(() => [
        {
            header: 'No',
            enableColumnFilter: false,
            accessorKey: "no",
            cell: ({ row }) => {
                return (
                    <Text variant='Poppins14Normal24lh'>{((currentPage - 1) * limit) + row?.index + 1}</Text>
                )
            },
        },
        {
            accessorKey: "badgeHistory.badgeCriteria",
            header: 'Criteria Name',
            cell: ({ row }) => {

                return (
                    <Badge sx={{
                        backgroundColor: row.original.color,
                        fontSize: "17px",
                        fontWeight: "bold",
                        px: '6px',
                        py: '3px',
                        borderRadius: "12px",
                    }}>{row.original.CriteriaName}</Badge>
                )
            },

            enableColumnFilter: true,
            filterType: 'multi-select-dropdown',
            options: gamificationCriteria?.data?.map((val: { _id: string, name: string }) => ({ value: val._id, label: val.name }))

        },

        {
            header: 'Badges',
            accessorKey: "badgeHistory.badgeId",
            cell: ({ row }) =>
                <div style={{ display: "flex", alignItems: "center", justifyContent: 'center', gap: "10px" }}>
                    {row.original.icon && (
                        <img
                            src={row.original.icon}
                            alt={row.original.badgeName}
                            style={{ width: "30px", height: "30px" }}
                        />
                    )}
                    <Text>{row.original.badgeName}</Text>
                </div>,
            enableColumnFilter: true,
            filterType: 'multi-select-dropdown',
            options: allBadges?.data?.map((val: { _id: string, name: string }) => ({ value: val._id, label: val.name }))

        },

        {
            header: 'Achieved Date',
            accessorKey: 'achievedAt',
            cell: ({ row }) => (
                <Text variant='Poppins14Normal24lh'>
                    {row.original.achievedAt}
                </Text>
            ),
            filterType: 'date',
        },
    ], [earnedBadges?.data]);
    return (
        <div className='main-content'>
            <TabelHeadingTxt Title='My Badges' Count={''} IsExportButtonShow={false} sx={{ backgroundColor: '#7743DB', color: 'white' }} />
            <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
            <DataTable
                loader={loader}
                columns={columns}
                data={transformedData || []}
                TotalLength={transformedData.length || 15}
                perPageCount={limit || 15}
                currentPage={paginations?.currentPage}
                onPerPageChange={(itemsPerPage: string) => {
                    if (searchParams?.size > 2) {
                        const parsedQuery = queryString.parse(location.search);

                        setSearchParams({
                            ...parsedQuery,
                            limit: itemsPerPage.toString(),
                        });
                    } else if (earnedBadges?.count < itemsPerPage) {
                        setSearchParams({
                            currentPage: '1',
                            limit: itemsPerPage.toString(),
                        });
                    }
                    else {
                        setSearchParams({
                            currentPage: currentPage.toString(),
                            limit: itemsPerPage.toString(),
                        });
                    }

                }}
                onPageChange={(value: string) => {

                    if (searchParams?.size > 2) {
                        const parsedQuery = queryString.parse(location.search);

                        setSearchParams({
                            ...parsedQuery,
                            currentPage: value.toString(),
                        });
                    } else {
                        setSearchParams({
                            currentPage: value.toString(),
                            limit: limit.toString(),
                        });
                    }

                }}

            />
        </div>
    )
}

export default BadgeHistory